import { render, staticRenderFns } from "./BranderList.vue?vue&type=template&id=0b7bac43&scoped=true&"
import script from "./BranderList.vue?vue&type=script&lang=js&"
export * from "./BranderList.vue?vue&type=script&lang=js&"
import style0 from "./BranderList.vue?vue&type=style&index=0&id=0b7bac43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7bac43",
  null
  
)

export default component.exports